import React from "react";
import { DashboardLayout, FormParser } from "../Components";
import { NavLink } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"
const RoleAdd = () => {
    const MastersModal=Masters.Role
    const formSubmit=(Data)=>{
        console.log(Data)
        axiosConfig.post("/account/roleview/",Data).then(res=>{
                   console.log(res)
        }).catch(error=>{
            console.log(error)
        })
      }
    return (
        <>
            <DashboardLayout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">Add Role</h5>
                    <NavLink to="/dashboard/masters/role" ><button className="btn btn-white">Manage</button></NavLink>
                </div>
                <FormParser modelObject={MastersModal} formSubmit={formSubmit}/>
            </DashboardLayout>
        </>
    )

}
export {RoleAdd}